export default __webpack_public_path__ + "static/067-3d6dae1fd7ad8e8fe8044a9476f144e4.jpg";